//菜单开户账号管理
import React from 'react'
import Manager from '../../public/components/Manager'
import AccountOpenDiv from './AccountOpenDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        {
            icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
                Tyan.pubForm.showDialog('开户账号管理', props => <AccountOpenDiv {...props} onSave={refreshPage} />)
        },
    ],
    columns: [
        { _text: '开票公司', field: 'InvoiceCompany', minWidth: 200, flex: 1, search: true, },
        { _text: '开票行中文名称', field: 'BankName', minWidth: 200, flex: 1, search: true, },
        { _text: '币别', field: 'CurrencyName', minWidth: 100, flex: 1, },
        { _text: '账号', field: 'AccountNumber', minWidth: 150, flex: 1, },
        { _text: '银行行号', field: 'BankNo', minWidth: 130, flex: 1, },
        { _text: 'Swift code', field: 'SwiftCode', minWidth: 130, flex: 1, },
        { _text: '开票行英文名称', field: 'BankNameE', minWidth: 200, flex: 1, search: true, },
        { _text: '开户行中文地址', field: 'BankAddress', minWidth: 200, flex: 1, search: true, },
        { _text: '开票行英文地址', field: 'BankAddressE', minWidth: 200, flex: 1, search: true, },
        { _date: '停用日期', field: 'SuspensionDate', minWidth: 110, flex: 1 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('开户账号管理', props => <AccountOpenDiv {...props} id={data.id} onSave={refreshPage} />)
    }
}

export default props => <Manager {...props} config={config} />